import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios, { AxiosError } from "axios";
import { baseUrl } from "../../../Utils/FileUpload";
import {
  Submit,
  AddSmsSettingTitle,
  SmsSettingTitle,
} from "../../../Utils/Constants";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCustomToasts from "../../../hooks/useCustomToast";

interface FormValues {
  gateway_name: string;
  api_key: string;
}

interface ErrorResponse {
  message: string;
}

export default function AddSmsSetting() {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>();
  const navigate = useNavigate();
  const { SuccessToast, ErrorToast } = useCustomToasts(navigate);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!isPasswordVisible);

  const onSubmit = async (data: FormValues) => {
    setIsButtonDisabled(true);

    try {
      const payload = {
        gateway_name: data.gateway_name,
        api_key: data.api_key,
      };
      // console.log(payload,"payload");
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${baseUrl}sms_setting/store`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        SuccessToast("Data added successfully", "/view_sms_setting");
      } else {
        ErrorToast("Failed to add");
      }
    } catch (err) {
      const axiosError = err as AxiosError;
      const errorMessage =
        (axiosError.response?.data as ErrorResponse)?.message ||
        "An unexpected error occurred";

      console.error("Error:", errorMessage);
      ErrorToast(errorMessage);
    } finally {
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 2000);
    }
  };

  // Prevent form submission on Enter key press
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={AddSmsSettingTitle}
        parent={SmsSettingTitle}
        title={AddSmsSettingTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody className="custom-input form-validation">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="g-3">
                <Col xs={12}>
                  <Label htmlFor="gateway_name">Gateway Name</Label>
                  <Controller
                    name="gateway_name"
                    control={control}
                    rules={{ required: "Gateway Name is required" }}
                    render={({ field }) => (
                      <>
                        <Input
                          type="text"
                          id="gateway_name"
                          placeholder="Gateway name"
                          {...field}
                          invalid={!!errors.gateway_name}
                          style={{
                            color: "var(--input-text-color)",
                            borderColor: errors.gateway_name ? "red" : "",
                          }}
                          onKeyDown={handleKeyDown}
                        />
                        {errors.gateway_name && (
                          <FormFeedback>
                            {errors.gateway_name.message}
                          </FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={12}>
                  <Label htmlFor="api_name">Api Key</Label>
                  <Controller
                    name="api_key"
                    control={control}
                    rules={{ required: "Api Key is required" }}
                    render={({ field }) => (
                      <>
                        <Input
                          type="text"
                          id="api_key"
                          placeholder="Api key"
                          {...field}
                          invalid={!!errors.api_key}
                          style={{
                            color: "var(--input-text-color)",
                            borderColor: errors.api_key ? "red" : "",
                          }}
                          onKeyDown={handleKeyDown}
                        />
                        {errors.api_key && (
                          <FormFeedback>{errors.api_key.message}</FormFeedback>
                        )}
                      </>
                    )}
                  />
                </Col>

                <Col xs={12} className="mt-2">
                  <Btn color="primary" disabled={isButtonDisabled}>
                    {Submit}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer
        toastStyle={{
          userSelect: "none",
        }}
      />
    </>
  );
}
